import { Link } from "react-router-dom";
import { Btn } from "@/components/shared";
import { HowItWorksSteps } from "@/components/HowItWorks";
import { ArrowLeft } from "lucide-react";

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-[#09090b] py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="flex items-center gap-1 text-zinc-500 hover:text-[#FF5722] font-mono text-sm uppercase mb-4"><ArrowLeft size={16} /> Sign in</Link>
        <div className="font-mono text-xs uppercase tracking-widest text-[#FF5722] mb-1">Client Guide</div>
        <h1 className="font-head font-black uppercase text-3xl sm:text-4xl text-white tracking-tight">How It Works</h1>
        <p className="text-zinc-400 mt-2 max-w-xl">Get an instant estimate and request service in minutes — no account required. Here's the whole flow, step by step.</p>
        <div className="mt-8"><HowItWorksSteps /></div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/request"><Btn data-testid="hiw-page-request">Request Service Now →</Btn></Link>
          <Link to="/login"><Btn variant="secondary">Back to sign in</Btn></Link>
        </div>
      </div>
    </div>
  );
}
